import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import Avatar from '@mui/material/Avatar';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import Tooltip from '@mui/material/Tooltip';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';


function title(role){
  switch (role) {
    case 458:
      return 'PG'
    case 459:
      return 'SG'
    case 460:
      return 'SF'
    case 461:
      return 'PF'
    case 462:
      return 'C'
    case 464:
      return 'G'
    case 463:
      return 'F'
    case 465:
      return 'UTIL'
    case 475:
      return 'UTIL'
    case 476:
      return 'CPT'
    default:
      return 'UTIL'
  }
}



export default function OptimizerTable({lineup, fpts, salary, isEditable, index, addedPlayers}) {


  const convertToCsv = () => {
    const csvString = [
      Object.keys(lineup[0]).join(','),
      ...lineup.map((row) => Object.values(row).join(',')),
    ].join('\n');

    // Create a Blob with the CSV string
    const blob = new Blob([csvString], { type: 'text/csv;charset=utf-8;' });

    // Create a download link
    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = 'optimizedLineup.csv';
    link.click();

    // Cleanup
    window.URL.revokeObjectURL(link.href);
  };


    return (
      <><Stack direction="row" spacing={1} justifyContent='center'>
        <Tooltip title="Download Lineup" placement="left" ><IconButton aria-label="download" onClick={convertToCsv} component='label' sx={{color:"blue"}}><CloudDownloadIcon/></IconButton></Tooltip>
        <Typography variant="h5" component="h5" gutterBottom>Optimized Lineup #{index + 1}</Typography>
        </Stack>
        <Stack direction="row" spacing={1} justifyContent='center'>
        <Typography variant='s1' align='center'>Salary: ${salary.toLocaleString()}</Typography>
        <Typography variant='s1' align='center'>Rem Sal: ${(50000 - salary).toLocaleString()}</Typography>
        <Typography variant='s1' align='center'>FPTS: {(fpts).toFixed(2)}</Typography>
        </Stack>
        <List sx={{ width: '100%'}} component="nav">
        
        {lineup.map((player, index) => 
          ( isEditable ?
            <>
          <ListItem key={player.ID} secondaryAction={<IconButton edge="end" color="error" aria-label="delete"><RemoveCircleOutlineIcon /></IconButton>}>
            <ListItemAvatar><Avatar>{title(player.Role)}</Avatar></ListItemAvatar>
            <ListItemText primary={player.Name} secondary={`${player.PPG} | $${(player.Salary).toLocaleString()}`} />
          </ListItem>
          <Divider />
          </>
          : 
          <>
          <ListItem key={player.ID} >
            <ListItemAvatar><Avatar>{title(player.Role)}</Avatar></ListItemAvatar>
            {player.Name === addedPlayers.find((user) => user === player.Name) ? <ListItemText primary={player.Name} secondary={`${player.PPG} | $${(player.Salary).toLocaleString()}`} style={{color: 'blue'}}/> :
            <ListItemText primary={player.Name} secondary={`${player.PPG} | $${(player.Salary).toLocaleString()}`} />}
          </ListItem>
          <Divider />
          </>)
        )}
      </List>
      </>
    );
  }